'use strict';

import zonedDate from '../utils/zoned-date';
import { format } from 'date-fns';

export async function init() {
    if (document.getElementById("performanceList") && document.getElementById("event-popup-btn")) {
        const apiUrl = "/api/event-instances";
        const currentDate = new Date();

        try {
            const response = await fetch(apiUrl);
            if (!response.ok) {
                throw new Error(`HTTP error! Status: ${response.status}`);
            }

            const data = await response.json();
            const container = document.getElementById("performanceList");
            const performance = parseInt(container.getAttribute('data-id'));
            const loadingBtn = document.querySelectorAll('.eventLoadingBtn');

            const filteredEvents = data.docs.filter(event => {
                const eventDate = zonedDate(event.startDateLocalAsUTC);
                const productionSeasonId = event.tessitura.productionSeasonId || event.tessitura?.data?.ProductionSeason?.Id;
                return eventDate >= currentDate && productionSeasonId == performance;
            });

            // This area handles the Buy button
            // If there is a single event instance:
            // - An a tag will be created, linking to the event TNEW page
            // If there are multiple event instances:
            // - The pop-up button will be shown
            if (filteredEvents.length >= 2) {
                const buyBtn = document.querySelectorAll('.eventPopupBtn');
                if (buyBtn) {
                    buyBtn.forEach(e => {
                        e.style.visibility = 'visible'
                        e.style.display = 'block'
                    });
                    loadingBtn.forEach(e => {
                        e.style.visibility = 'hidden'
                        e.style.display = 'none'
                    });
                }
            } else if (filteredEvents.length == 1) {
                const eventBtnsContainer = document.querySelectorAll('.event-btns');
                eventBtnsContainer.forEach(e => {
                    const singleEventLink = document.createElement("a");
                    singleEventLink.classList.add("event-btns__btn");
                    singleEventLink.classList.add("btn--theme-dark");
                    singleEventLink.classList.add("btn");
                    const productionSeasonId = filteredEvents[0].tessitura?.productionSeasonId;
                    const eventId = filteredEvents[0].tessitura?.performanceId;
                    const domain = container.getAttribute('data-domain');
                    const eventUrl = `${domain}${productionSeasonId}/${eventId}`;
                    singleEventLink.href = eventUrl;
                    singleEventLink.innerHTML = `Buy Tickets`;
                    e.prepend(singleEventLink);
                });
                loadingBtn.forEach(e => {
                    e.style.visibility = 'hidden'
                    e.style.display = 'none'
                });
            } else {
                loadingBtn.forEach(e => {
                    e.style.visibility = 'hidden'
                    e.style.display = 'none'
                });
            }

            // Ascending order
            filteredEvents.sort((a, b) => {
                const dateA = new Date(a.startDateLocalAsUTC);
                const dateB = new Date(b.startDateLocalAsUTC);
                return dateA - dateB;
            });

            filteredEvents.forEach(event => {
                const startDate = zonedDate(event.startDateLocalAsUTC);
                const productionSeasonId = event.tessitura.productionSeasonId || event.tessitura?.data?.ProductionSeason?.Id;
                const eventId = event.tessitura.performanceId || event.tessitura?.data?.Id;

                if (!startDate || !productionSeasonId || !eventId) {
                    console.warn("Missing expected properties in event:", event);
                    return;
                }

                // Format the start date and time
                const eventDate = startDate;
                const formattedDate = format(eventDate, 'EEE, MMM dd, yyyy');
                const formattedTime = format(eventDate, 'hh:mm a');

                const eventElement = document.createElement("a");
                eventElement.classList.add("performance-popup-item");
                const domain = container.getAttribute('data-domain');
                const eventUrl = `${domain}${productionSeasonId}/${eventId}`;
                eventElement.href = eventUrl;
                eventElement.innerHTML = `
                    <p class="performance-popup-item__title">
                    <strong>${formattedDate}</strong> at <strong>${formattedTime}</strong>
                    </p>
                    <svg class="o-icon o-icon--arrow-right">
                        <use xlink:href="#arrow-right">
                            <symbol id="arrow-right" viewBox="0 0 16 16">
                                <path d="M16 8.0032c-.0007-.2203-.0945-.4301-.2581-.5775l-5.7124-5.6978c-.1467-.1647-.3569-.2587-.5775-.2581-.4007-.013-.7361.3013-.7491.702-.0004.013-.0005.0261-.0002.0392-.0056.2011.0686.3963.2065.5429l1.9302 1.9641 3.42 3.1191.1726-.4307-2.7739-.1726H.7593c-.4033-.0158-.743.2984-.7587.7017-.0009.0226-.0007.0452.0005.0678-.0204.4031.2899.7463.693.7667.0217.001.0434.0012.0652.0003h10.898l2.7739-.1726-.1726-.4219-3.42 3.1103-1.9294 1.96c-.1392.1458-.2137.3415-.2065.5429-.0087.4008.3092.7328.7101.7415.0131.0003.0262.0002.0393-.0002.2116-.002.4134-.0892.5598-.242l5.7269-5.7115c.1637-.146.2585-.3542.2612-.5736z"></path>
                            </symbol>
                        </use>
                    </svg>
                `;

                container.appendChild(eventElement);
            });
        } catch (error) {
            console.error("Error fetching data:", error);
        }
    }
}
